import { WordSearchPuzzleModel } from './word-search-puzzle.model';

export class InitWordSearchPuzzle {
  static readonly type = '[WordSearchPuzzle] Init';
  constructor(public payload: WordSearchPuzzleModel) {}
}

export class PersistWordSearchState {
  static readonly type = '[WordSearchPuzzle] Persist user input';
  constructor(public payload: WordSearchPuzzleModel) {}
}
